export default __webpack_public_path__ + "static/media/0a2d27e2-c1ab-4b62-9052-222538e9c9d8.36e227e2.eot";